module.exports = __webpack_public_path__ + "9513c65d228e8772bc78c89b18feafdd.woff";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/LeagueGothic/leaguegothic-italic-webfont.woff
// module id = 429
// module chunks = 0